import React, { useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Text from '../components/inputTxt/Text';
import UploadIMG from "../components/uploads/UploadIMG";
import { useEffect } from 'react';
import { createAndUpdateBusCondoDetail, getBusCondoDetail } from '../api/business_api'
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function CondoRent() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [txtEnDetailRoom1, setTxtEnDetailRoom1] = useState('');
    const [txtThDetailRoom1, setTxtThDetailRoom1] = useState('');
    const [txtEnDetailRoom2, setTxtEnDetailRoom2] = useState('');
    const [txtThDetailRoom2, setTxtThDetailRoom2] = useState('');
    const [txtEnDetailRoom3, setTxtEnDetailRoom3] = useState('');
    const [txtThDetailRoom3, setTxtThDetailRoom3] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [images3, setImages3] = useState([]);
    const [imagesFromApi3, setImagesFromApi3] = useState([]);
    const [txtEnTitle1, setTxtEnTitle1] = useState('');
    const [txtThTitle1, setTxtThTitle1] = useState('');
    const [txtEnTitle2, setTxtEnTitle2] = useState('');
    const [txtThTitle2, setTxtThTitle2] = useState('');
    const [txtEnTitle3, setTxtEnTitle3] = useState('');
    const [txtThTitle3, setTxtThTitle3] = useState('');

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    const handleSelectedImages3 = (images) => {
        setImages3(images);
    };
    const handleSelectedRemoveImg3 = (data) => {
        setImages3(data);
    };

    const handleChangeInput50 = async (event,inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 50) {
            const result = await alertOverLimit(); 
                if (result.isConfirmed) {
                    const trimmedValue = inputValue.substring(0, 50); // Trim to 50 characters
                    //const lastSpaceIndex = trimmedValue.lastIndexOf(" ");
                    const finalValue = trimmedValue.substring(0); // Trim at last space
                    if (inpName=='enTitle1') {                    
                        setTxtEnTitle1(finalValue);
                    }
                    else if (inpName == 'thTitle1') {
                        setTxtThTitle1(finalValue);
                    }
                    else if (inpName=='enTitle2') {                    
                        setTxtEnTitle2(finalValue);
                    }
                    else if (inpName == 'thTitle2') {
                        setTxtThTitle2(finalValue);
                    }
                    else if (inpName=='enTitle3') {                    
                        setTxtEnTitle3(finalValue);
                    }
                    else if (inpName == 'thTitle3') {
                        setTxtThTitle3(finalValue);
                    }
                }
                else {
                    if (inpName == 'enTitle1') {                    
                        setTxtEnTitle1(inputValue);
                    }
                    else if (inpName == 'thTitle1') {
                        setTxtThTitle1(inputValue);
                    }
                    else if (inpName=='enTitle2') {                    
                        setTxtEnTitle2(inputValue);
                    }
                    else if (inpName == 'thTitle2') {
                        setTxtThTitle2(inputValue);
                    }
                    else if (inpName=='enTitle3') {                    
                        setTxtEnTitle3(inputValue);
                    }
                    else if (inpName == 'thTitle3') {
                        setTxtThTitle3(inputValue);
                    }
                }
        }
        else {
            if (inpName == 'enTitle1') {                    
                setTxtEnTitle1(inputValue);
            }
            else if (inpName == 'thTitle1') {
                setTxtThTitle1(inputValue);
            }
            else if (inpName=='enTitle2') {                    
                setTxtEnTitle2(inputValue);
            }
            else if (inpName == 'thTitle2') {
                setTxtThTitle2(inputValue);
            }
            else if (inpName=='enTitle3') {                    
                setTxtEnTitle3(inputValue);
            }
            else if (inpName == 'thTitle3') {
                setTxtThTitle3(inputValue);
            }
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    window.location.reload();
                }
                else { }
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const handleSaveBtn = async () => {
        try {
                const formatedBodyToServer = {
                    type: 'for_rent',
                    _id: editId??null,
                    description_en: txtEnDesc,
                    description_th: txtThDesc,
                    title1_room_en: txtEnTitle1,
                    title1_room_th: txtThTitle1,
                    title2_room_en: txtEnTitle2,
                    title2_room_th: txtThTitle2,
                    title3_room_en: txtEnTitle3,
                    title3_room_th: txtThTitle3,
                    room1_description_en: txtEnDetailRoom1,
                    room1_description_th: txtThDetailRoom1,
                    room2_description_en: txtEnDetailRoom2,
                    room2_description_th: txtThDetailRoom2,
                    room3_description_en: txtEnDetailRoom3,
                    room3_description_th: txtThDetailRoom3,
                    room1_gallery: images1 ?? null,
                    room2_gallery: images2 ?? null,
                    room3_gallery: images3 ?? null,
                }
                if (
                    !formatedBodyToServer.description_en ||
                    !formatedBodyToServer.description_th ||
                    !formatedBodyToServer.title1_room_en ||
                    !formatedBodyToServer.title1_room_th ||
                    !formatedBodyToServer.title2_room_en||
                    !formatedBodyToServer.title2_room_th ||
                    !formatedBodyToServer.title3_room_en ||
                    !formatedBodyToServer.title3_room_th ||
                    !formatedBodyToServer.room1_description_en ||
                    !formatedBodyToServer.room1_description_th ||
                    !formatedBodyToServer.room2_description_en ||
                    !formatedBodyToServer.room2_description_th ||
                    !formatedBodyToServer.room3_description_en ||
                    !formatedBodyToServer.room3_description_th ||
                    !formatedBodyToServer.room1_gallery.length > 0 ||
                    !formatedBodyToServer.room2_gallery.length > 0 ||
                    !formatedBodyToServer.room3_gallery.length > 0
                ) {
                    await alertValidate();
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                          (async () => {
                            await setLoading(true);
                            const response = await createAndUpdateBusCondoDetail('',formatedBodyToServer);
                            setLoading(false)
                            if (response.status == "success"||response.status == 200) {
                                const result = await alertSaved();
                                  if (result.isConfirmed) {
                                    window.location.reload();
                                  }
                              }
                          })();
                        }
                }
        } catch (error) {
            console.log('found error ', error)
        }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const param = {
                type: 'for_rent',
            }

            const response = await getBusCondoDetail(param)

            setEditId(response?.data?.data?._id)

            if (response?.data?.data?.description_en) {
                setTxtEnDesc(response?.data?.data?.description_en)
            }
            if (response?.data?.data?.description_th) {
                setTxtThDesc(response?.data?.data?.description_th)
            }

            if (response?.data?.data?.title1_room_en) {
                setTxtEnTitle1(response?.data?.data?.title1_room_en)
            }
            if (response?.data?.data?.title1_room_th) {
                setTxtThTitle1(response?.data?.data?.title1_room_th)
            }
            if (response?.data?.data?.title2_room_en) {
                setTxtEnTitle2(response?.data?.data?.title2_room_en)
            }
            if (response?.data?.data?.title2_room_th) {
                setTxtThTitle2(response?.data?.data?.title2_room_th)
            }
            if (response?.data?.data?.title3_room_en) {
                setTxtEnTitle3(response?.data?.data?.title3_room_en)
            }
            if (response?.data?.data?.title3_room_th) {
                setTxtThTitle3(response?.data?.data?.title3_room_th)
            }

            if (response?.data?.data?.room1_description_en) {
                setTxtEnDetailRoom1(response?.data?.data?.room1_description_en)
            }
            if (response?.data?.data?.room1_description_th) {
                setTxtThDetailRoom1(response?.data?.data?.room1_description_th)
            }

            if (response?.data?.data?.room2_description_en) {
                setTxtEnDetailRoom2(response?.data?.data?.room2_description_en)
            }
            if (response?.data?.data?.room2_description_th) {
                setTxtThDetailRoom2(response?.data?.data?.room2_description_th)
            }

            if (response?.data?.data?.room3_description_en) {
                setTxtEnDetailRoom3(response?.data?.data?.room3_description_en)
            }
            if (response?.data?.data?.room3_description_th) {
                setTxtThDetailRoom3(response?.data?.data?.room3_description_th)
            }

            const room1_gallery = response?.data?.data?.room1_gallery;
            if (room1_gallery && Array.isArray(room1_gallery)) {
                const images = await Promise.all(room1_gallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi1(images);
            }
            const room2_gallery = response?.data?.data?.room2_gallery;
            if (room2_gallery && Array.isArray(room2_gallery)) {
                const images = await Promise.all(room2_gallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi2(images);
            }
            const room3_gallery = response?.data?.data?.room3_gallery;
            if (room3_gallery && Array.isArray(room3_gallery)) {
                const images = await Promise.all(room3_gallery.map(async (imageSrc, index) => {
                    return {
                        id: index,
                        status: false,
                        src: imageSrc || '',
                        file: imageSrc ? await urlToBlob(imageSrc) : null,
                        size: 1024 * 1024 * 4, // hard-coded to pass validation
                        type: 'image/jpg' // hard-coded to pass validation
                    };
                }));
                setImagesFromApi3(images);
            }
        } catch (error) {
            console.log('error', error);
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])

  return (
    <>
        <style>
            {`
                .upload {
                    display: flex;
                    flex-direction: column; /* Stack items vertically by default */
                    position: relative;
                }
                .thumbsContainer {
                    display: flex; /* Change to flex to align children horizontally */
                    flex-wrap: wrap; /* Allow wrapping to the next line if needed */
                    width: 100%;
                    margin-top: 0;
                }
                .thumb, .boxthumb {
                    display: inline-flex;
                    border-radius: 0;
                    margin: 0 5px 10px 0; /* Margin to space items horizontally and vertically */
                    width: 100px; /* Adjust the width to fit your design */
                    height: 70px;
                    box-sizing: border-box;
                    position: relative;
                    margin-top: 1rem;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
                @media only screen and (max-width: 767px) {
                    .thumb, .boxthumb {
                        margin-left: 0;
                        margin-right: 15px;
                    }
                    .remark-dt {
                        margin-top: -25px;
                    }
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BUSINESS"} />
        <Menu
            parentmenu={"infoBusiness"}
            activemenu={"infoCondoRent"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-business.png" className="ic-user01 me-2" alt="" />
                                BUSINESS<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" />  CONDOMINIUM<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> CONDO FOR RENT
                            </font>
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Condo For Rent <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDesc}
                                    onChange={(newData) => {
                                        setTxtEnDesc(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDesc}
                                    onChange={(newData) => {
                                        setTxtThDesc(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <Text
                                    value={txtEnTitle1}
                                    onChange={(e) => handleChangeInput50(e,'enTitle1')}
                                    placeholder="Title Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <Text
                                    value={txtThTitle1}
                                    onChange={(e) => handleChangeInput50(e,'thTitle1')}
                                    placeholder="ชื่อห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDetailRoom1}
                                    onChange={(newData) => {
                                        setTxtEnDetailRoom1(newData);
                                    }}
                                    placeholder="Description Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDetailRoom1}
                                    onChange={(newData) => {
                                        setTxtThDetailRoom1(newData);
                                    }}
                                    placeholder="รายละเอียดห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <Text
                                    value={txtEnTitle2}
                                    onChange={(e) => handleChangeInput50(e,'enTitle2')}
                                    placeholder="Title Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <Text
                                    value={txtThTitle2}
                                    onChange={(e) => handleChangeInput50(e,'thTitle2')}
                                    placeholder="ชื่อห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDetailRoom2}
                                    onChange={(newData) => {
                                        setTxtEnDetailRoom2(newData);
                                    }}
                                    placeholder="Description Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDetailRoom2}
                                    onChange={(newData) => {
                                        setTxtThDetailRoom2(newData);
                                    }}
                                    placeholder="รายละเอียดห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages2}
                                    images={imagesFromApi2}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg2}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <Text
                                    value={txtEnTitle3}
                                    onChange={(e) => handleChangeInput50(e,'enTitle3')}
                                    placeholder="Title Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <Text
                                    value={txtThTitle3}
                                    onChange={(e) => handleChangeInput50(e,'thTitle3')}
                                    placeholder="ชื่อห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDetailRoom3}
                                    onChange={(newData) => {
                                        setTxtEnDetailRoom3(newData);
                                    }}
                                    placeholder="Description Room *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDetailRoom3}
                                    onChange={(newData) => {
                                        setTxtThDetailRoom3(newData);
                                    }}
                                    placeholder="รายละเอียดห้อง *"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <UploadIMG
                                    limit={5}
                                    onSelectedImages={handleSelectedImages3}
                                    images={imagesFromApi3}
                                    txtDetail={"jpg. / 800x450 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg3}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                            CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleSaveBtn();
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default CondoRent;